import { eventChannel } from 'redux-saga';
import { all, takeLatest, fork, take, select, put } from 'redux-saga/effects';
import { isNil, prop, unless } from 'ramda';

import { UserActions, UserTypes } from './index';
import { selectUserId } from '../auth';
import { usersRef } from '../../shared/services/firebase';

const bookingEntry = prop('key');

const createUserChannel = userRef =>
  eventChannel(emitter => {
    const onValueReceived = snapshot => {
      const value = snapshot.val();
      setTimeout(() => unless(isNil, emitter)(value));
    };

    userRef.on('value', onValueReceived);
    return () => userRef.off('value', onValueReceived);
  });

function* startListeningForUserData(userRef) {
  const listenForUserData = yield createUserChannel(userRef);
  while (true) {
    const data = yield take(listenForUserData);
    yield put(UserActions.setUserData(data));
  }
}

const createUserBookingsChannel = userBookingsRef =>
  eventChannel(emitter => {
    const onValueReceived = snapshot => {
      setTimeout(() => unless(isNil, emitter)(bookingEntry(snapshot)));
    };

    userBookingsRef.on('child_added', onValueReceived);
    return () => userBookingsRef.off('child_added', onValueReceived);
  });

function* startListeningForUserBookings(userBookingsRef) {
  const listenForUserBookingsData = yield createUserBookingsChannel(userBookingsRef);
  while (true) {
    const data = yield take(listenForUserBookingsData);
    yield put(UserActions.bookingAdded(data));
  }
}

function* listenForUserDataSaga() {
  const currentUserId = yield select(selectUserId);
  const userRef = usersRef.child(currentUserId);
  const userBookingsRef = userRef.child('bookings');
  yield fork(startListeningForUserData, userRef);
  yield fork(startListeningForUserBookings, userBookingsRef);
}

export default function* startupSaga() {
  yield all([takeLatest(UserTypes.LISTEN_FOR_USER_DATA, listenForUserDataSaga)]);
}
